var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["../elements/combobox.html"] = require( "../elements/combobox.html" );
dependencies["./table.html"] = require( "./table.html" );




var shim = require("C:/Users/kaharmanny/source/repos/rentmagic.frontend/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["views/content/quickedit.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("../elements/combobox.html", false, "views/content/quickedit.html", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("combo", t_1);
output += "\r\n";
env.getTemplate("./table.html", false, "views/content/quickedit.html", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
context.setVariable("table", t_4);
output += "\r\n\r\n<div class=\"content content-flex\">\r\n\t<form class=\"form-view grid row\">\r\n\t\t<!--<input type=\"hidden\" name=\"RentalType\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"formType"), env.opts.autoescape);
output += "\">-->\r\n\t\t<div class=\"col-xs-12 col-sm-6 col-md-3\">\r\n\t\t\t<label class=\"form-field\">\r\n\t\t\t\t<div class=\"form-label\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"Type"), env.opts.autoescape);
output += ":</div>\r\n\t\t\t\t<div class=\"form-input required-field\">\r\n\t\t\t\t\t";
output += runtime.suppressValue((lineno = 10, colno = 29, runtime.callWrap(runtime.memberLookup((t_1),"constructCombobox"), "combo[\"constructCombobox\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session"),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"combobox")),"type")])), env.opts.autoescape);
output += "\r\n\t\t\t\t</div>\r\n\t\t\t</label>\r\n\t\t</div>\r\n\r\n\t\t<div class=\"col-xs-12 col-sm-6 col-md-3\">\r\n\t\t\t<label class=\"form-field\">\r\n\t\t\t\t<div class=\"form-label\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"Value"), env.opts.autoescape);
output += ":</div>\r\n\t\t\t\t<div class=\"form-input required-field\">\r\n\t\t\t\t\t";
output += runtime.suppressValue((lineno = 19, colno = 29, runtime.callWrap(runtime.memberLookup((t_1),"constructCombobox"), "combo[\"constructCombobox\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session"),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"combobox")),"value")])), env.opts.autoescape);
output += "\r\n\t\t\t\t</div>\r\n\t\t\t</label>\r\n\t\t</div>\r\n\r\n\t\t";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"selectProductionAssistant")) {
output += "\r\n\t\t<div class=\"col-xs-12 col-sm-6 col-md-3\">\r\n\t\t\t<label class=\"form-field\">\r\n\t\t\t\t<div class=\"form-label\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"ProductionAssistant"), env.opts.autoescape);
output += ":</div>\r\n\t\t\t\t<div class=\"form-input required-field\">\r\n\t\t\t\t\t";
output += runtime.suppressValue((lineno = 29, colno = 29, runtime.callWrap(runtime.memberLookup((t_1),"constructCombobox"), "combo[\"constructCombobox\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session"),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"combobox")),"productionAssistant")])), env.opts.autoescape);
output += "\r\n\t\t\t\t</div>\r\n\t\t\t</label>\r\n\t\t</div>\r\n\t\t";
;
}
output += "\r\n\t</form>\r\n\r\n\t";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"rows")),"length") > 0) {
output += "\r\n\t\t<div class=\"table-view unsortable\">\r\n\t\t\t<form class=\"table-container\">\r\n\t\t\t\t<div class=\"table-index sticky-div\">\r\n\t\t\t\t\t<div class=\"table-row\">\r\n\t\t\t\t\t\t<!-- <div class=\"field checkbox selection-box\"><div class=\"ellipsis\"><input type=\"checkbox\" title=\"Select all\"></div></div> -->\r\n\t\t\t\t\t\t<label class=\"table-cell checkbox selection-box\"><div class=\"ellipsis\"><input type=\"checkbox\" title=\"Select all\"></div></label>\r\n\r\n\t\t\t\t\t\t";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"useGroupedRows") == true) {
output += "\r\n\t\t\t\t\t\t<label class=\"table-cell checkbox selection-box\"><div class=\"ellipsis\"></div></label>\r\n\t\t\t\t\t\t";
;
}
output += "\r\n\r\n\t\t\t\t\t\t";
frame = frame.push();
var t_9 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"columns");
if(t_9) {var t_8 = t_9.length;
for(var t_7=0; t_7 < t_9.length; t_7++) {
var t_10 = t_9[t_7];
frame.set("col", t_10);
frame.set("loop.index", t_7 + 1);
frame.set("loop.index0", t_7);
frame.set("loop.revindex", t_8 - t_7);
frame.set("loop.revindex0", t_8 - t_7 - 1);
frame.set("loop.first", t_7 === 0);
frame.set("loop.last", t_7 === t_8 - 1);
frame.set("loop.length", t_8);
output += "\t\t\t\t\r\n\t\t\t\t\t\t\t\t<div class=\"table-cell ";
output += runtime.suppressValue((runtime.memberLookup((t_10),"Type") == "Money" || runtime.memberLookup((t_10),"Type") == "Decimal" || runtime.memberLookup((t_10),"Type") == "Int"?"number " + runtime.memberLookup((t_10),"Type"):""), env.opts.autoescape);
output += "\" data-column=\"";
output += runtime.suppressValue(runtime.memberLookup((t_10),"Name"), env.opts.autoescape);
output += "\" title=\"";
output += runtime.suppressValue(runtime.memberLookup((t_10),"Title"), env.opts.autoescape);
output += "\">\r\n\t\t\t\t\t\t\t\t\t<div class=\"ellipsis\">\r\n\t\t\t\t\t\t\t\t\t\t";
output += runtime.suppressValue(runtime.memberLookup((t_10),"Title"), env.opts.autoescape);
output += "\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<!-- <div class=\"field\" title=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "i"), env.opts.autoescape);
output += "\"><div class=\"ellipsis\"><input type=\"checkbox\"></div></div> -->";
;
}
}
frame = frame.pop();
output += "\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\r\n\t\t\t\t<div class=\"table-body bulkedit\">\r\n\t\t\t\t\t<div class=\"table-rows\">\r\n\t\t\t\t\t\t";
frame = frame.push();
var t_13 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"rows");
if(t_13) {var t_12 = t_13.length;
for(var t_11=0; t_11 < t_13.length; t_11++) {
var t_14 = t_13[t_11];
frame.set("row", t_14);
frame.set("loop.index", t_11 + 1);
frame.set("loop.index0", t_11);
frame.set("loop.revindex", t_12 - t_11);
frame.set("loop.revindex0", t_12 - t_11 - 1);
frame.set("loop.first", t_11 === 0);
frame.set("loop.last", t_11 === t_12 - 1);
frame.set("loop.length", t_12);
output += "<div class=\"table-row  ";
output += runtime.suppressValue((runtime.memberLookup((t_14),"groupedRow") == true?"grouped-row":""), env.opts.autoescape);
output += "\" data-row-index=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"), env.opts.autoescape);
output += "\" style=\"";
output += runtime.suppressValue((lineno = 62, colno = 126, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"getCssInfo"), "window[\"getCssInfo\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0")])), env.opts.autoescape);
output += "\" data-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_14),"used")),"ItemID"), env.opts.autoescape);
output += "\">\r\n\t\t\t\t\t\t\t<label class=\"table-cell checkbox selection-box\"><input type=\"checkbox\" data-commit-checkbox=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"), env.opts.autoescape);
output += "\" title=\"Select\" ";
output += runtime.suppressValue((runtime.memberLookup((t_14),"selected")?"checked":""), env.opts.autoescape);
output += "></label>\r\n\t\t\t\t\t\t\t<!--<div class=\"table-cell delete-row material-icons\" title=\"Verwijderen\"><div class=\"ellipsis\">&#xe5cd;</div></div>-->\r\n\r\n\t\t\t\t\t\t\t";
if(runtime.memberLookup((t_14),"groupedRow")) {
output += "\r\n\t\t\t\t\t\t\t<div class=\"table-cell dropdown-info material-icons\" data-toggle-lower-field>&#xe313;</div>\r\n\t\t\t\t\t\t\t";
;
}
else {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"useGroupedRows") == true) {
output += "\r\n\t\t\t\t\t\t\t<div class=\"table-cell\"></div>\r\n\t\t\t\t\t\t\t";
;
}
;
}
output += "\r\n\r\n\t\t\t\t\t\t\t";
var t_15;
t_15 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0");
frame.set("index", t_15, true);
if(frame.topLevel) {
context.setVariable("index", t_15);
}
if(frame.topLevel) {
context.addExport("index", t_15);
}
output += "\r\n\t\t\t\t\t\t\t";
frame = frame.push();
var t_18 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"columns");
if(t_18) {var t_17 = t_18.length;
for(var t_16=0; t_16 < t_18.length; t_16++) {
var t_19 = t_18[t_16];
frame.set("col", t_19);
frame.set("loop.index", t_16 + 1);
frame.set("loop.index0", t_16);
frame.set("loop.revindex", t_17 - t_16);
frame.set("loop.revindex0", t_17 - t_16 - 1);
frame.set("loop.first", t_16 === 0);
frame.set("loop.last", t_16 === t_17 - 1);
frame.set("loop.length", t_17);
output += runtime.suppressValue((lineno = 74, colno = 28, runtime.callWrap(runtime.memberLookup((t_4),"setColumnCell"), "table[\"setColumnCell\"]", context, [t_19,"",runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"),runtime.memberLookup((runtime.memberLookup((t_14),"used")),runtime.memberLookup((t_19),"Name")),runtime.contextOrFrameLookup(context, frame, "window"),runtime.memberLookup((runtime.memberLookup((t_14),"cells")),runtime.memberLookup((t_19),"Name")),runtime.memberLookup((runtime.memberLookup((t_14),"editable")),runtime.memberLookup((t_19),"Name")),runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"Data")),"Metadata")),runtime.contextOrFrameLookup(context, frame, "index"))])), env.opts.autoescape);
output += "\r\n\t\t\t\t\t\t\t";
;
}
}
frame = frame.pop();
output += "\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t";
;
}
}
frame = frame.pop();
output += "\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</form>\r\n\t\t</div>\r\n\t";
;
}
output += "\r\n</div>\r\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["views/content/quickedit.html"] , dependencies)